import faqs from './faqsData.json';

export default class Faqs {
    faqsToShow(roleId) {
		return faqs[roleId]?.data ?? [];
	}
}
